import Axios from 'axios';
import * as Constants from './constants.js';

import store from '../../store'
const env_name =(typeof process.env.REACT_APP_DATALOADER_APP_ENV  !== "undefined" )  ? process.env.REACT_APP_DATALOADER_APP_ENV : 'dev'
Axios.interceptors.request.use(
  config => {
    const token = store.getState().auth.accessToken;
    if (token) {
      if (config.method !== 'put') {
        config.headers.Authorization = `Bearer ${token}`
        
      }
      if (config.method === 'put') {
        config.headers['Content-Type'] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        
      }
      
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

/**
 * this function get Pre Signed URLS
 * @param {*} token : user toketn
 * @param {*} msg  : let os file names.
 */
export async function getSignedUrl(msg) {

  const url = Constants[env_name].PRE_SIGNED_URL;
  try {
    let signedURlMessage = JSON.stringify(msg,0,4);
    console.log("getSignedUrl.............",signedURlMessage)
    console.log("token....","Bearer ",store.getState().auth.accessToken)
    const promiseObj = Axios.post(url, signedURlMessage);
    const promiseWait = await promiseObj;
    return promiseWait.data;
  } catch (error) {
    console.log("Error while receiving presigned url<getSignedUrl>......", error)
  }

}

export async function getOriginalFileService(fileId, contenttype) {
  try {
    let url = Constants[env_name].FILEDOWNLOAD_OPERATION_URL + fileId
    console.log('url getservice::',url)
    //const promiseObj = Axios.get(url);
    const promiseObj = Axios.get(url,{
      responseType: 'arraybuffer',
      headers: {
        'Accept': contenttype,
        'Content-Type': contenttype
      }
    }
  );
    const promiseWait = await promiseObj;
    return promiseWait;
  } catch (error) {
    console.log("Error while receiving S3 response <getService......", error)
  }

}

export async function uploadFile(url, file) {
  return Axios.put(url, file);
}


export async function getService(fileId) {
  try {
    let url = Constants[env_name].FILEDOWNLOAD_OPERATION_URL + fileId
    const promiseObj = Axios.get(url);
    const promiseWait = await promiseObj;
    return promiseWait;
  } catch (error) {
    console.log("Error while receiving S3 response <getService......", error)
  }

}

export async function fetchStatus(user) {

  let url = Constants[env_name].STATUS_OPERATION_URL;

  try {
    const statusPromise = Axios.get(url + user);
    return statusPromise;
  } catch (error) {
    console.log("Error while receiving recent history status response <fetchStatus>......", error)
  }
}


export async function sendLoadCompleteMessage(message) {
  try {
    let url = Constants[env_name].NOTIFY_OPERATION_URL
    const finalMessage=Axios.post(url,JSON.stringify(message));
    const finalMessagePromise = await finalMessage;
    return finalMessagePromise.status;
  } catch (error) {
    console.log("Error while sending final batch api call PDF service <notifyLoadComplete>......", error)
  }
}